module.exports = __webpack_public_path__ + "img/draw-btn.ec5c4f06.svg";